import { HEX_18232F, HEX_646A7E, HEX_9BA4B6, HEX_E2E8F0 } from '@tanium/colors';
import { defineColor, Primary4 } from '@tanium/react-theme-definition';

export const ContainerFill = defineColor([HEX_E2E8F0, HEX_18232F]);
export const ContainerBorder = defineColor([HEX_E2E8F0, HEX_18232F]);
export const ContainerShadow = Primary4;
export const InputText = defineColor([HEX_646A7E, HEX_9BA4B6]);
